import { useIntersectionObserver, whenever } from '@vueuse/core';
import { ref, watch, type Ref } from 'vue';
import { trackEmptySearch } from '@/entities/analytics';

const EMPTY_SEARCH_VISIBLE_RATIO = 0.5;

export function useEmptySearchGoal(
  target: Readonly<Ref<HTMLElement | null | undefined>>,
  isEmptySearch: Readonly<Ref<boolean>>,
): void {
  const isVisible = ref(false);

  watch(target, () => {
    isVisible.value = false;
  });

  useIntersectionObserver(
    target,
    ([entry]) => {
      isVisible.value = Boolean(entry?.isIntersecting) && entry.intersectionRatio >= EMPTY_SEARCH_VISIBLE_RATIO;
    },
    { threshold: EMPTY_SEARCH_VISIBLE_RATIO },
  );

  whenever(() => isVisible.value && isEmptySearch.value, trackEmptySearch, { once: true });
}
